<template>
    <div>
        <tax-filter :exportExcel="exportTaxExcel"></tax-filter>
        <taxExport-table></taxExport-table>
    </div>
</template>

<script>

import taxFilter from "./tax-filter";
import axios from "axios";
import taxExportTable from "./taxExport-table";
import $ from "jquery";
import { ApiUrl } from '@/common/api.service'
import { KTApp } from '@/plugins/core/app'
import toastr from "toastr";
import { i18n } from '@/plugins/i18n'

export default {

    components: {
        'tax-filter': taxFilter,
        'taxExport-table': taxExportTable
    },

    data() {
        return {
            query: {}
        }
    },

    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        }
    },

    methods: {
        exportTaxExcel(e, query){
            this.query = {
                'query': query
            }

            let form = $('#tax_export_form')
            let btn = $('#tax_export_btn')
            form.validate({
                rules: {
                    from_date: {
                        required: true,
                    },
                    to_date: {
                        required: true,
                    }
                }
            })

            if(!form.valid()) {
                return
            }

            KTApp.progress(btn)

            axios({
                url: ApiUrl.path('reports/tax-excel-export'),
                method: 'GET',
                params: this.query,
            }).then(
                response => {
                    this.$store.dispatch('reports/fetchTaxExports')

                    // this.toastr.success(response.data.message)
                    KTApp.unprogress(btn)
                    var fileLink = document.createElement('a');

                    fileLink.href = response.data.data;
                    fileLink.setAttribute('download', 'tax_export.xlsx');
                    document.body.appendChild(fileLink);

                    fileLink.click();
                })
                .catch(({response}) => {
                KTApp.unprogress(btn)
                this.toastr.error(response.data.message)
            })
        }
    }
}
</script>